import classNames from 'classnames'
import React from 'react'

import { Button, ButtonProps } from '../button/button.js'
import { Container } from '../container/container.js'
import { GridColumn } from '../grid/grid-column.js'
import { Grid } from '../grid/grid.js'
import { ChevronLeftIcon, PhoneIcon } from '../icon/icon.js'
import { SamsungLogo } from '../logo/logo.js'

export interface HeaderProps {
    backButton?: ButtonProps
    className?: string
    helpButton?: ButtonProps
    url?: string
}

export const Header = (props: HeaderProps): JSX.Element => {
    const { backButton, helpButton, url } = props

    const className: string = classNames('header', props.className)

    return (
        <header className={className}>
            <Container>
                <Grid align={['middle-xs']} gutter="mobile" noWrap={true}>
                    <GridColumn className="header__column" width={['min-xs']}>
                        {backButton && (
                            <Button
                                {...backButton}
                                iconClassName="button__icon--large"
                                iconLeft={ChevronLeftIcon}
                                style="link"
                            />
                        )}
                    </GridColumn>
                    <GridColumn className="header__logo-column" width={['xs']}>
                        <SamsungLogo className="header__logo" url={url} />
                    </GridColumn>
                    <GridColumn className="header__column h-text-right" width={['min-xs']}>
                        {helpButton && (
                            <Button
                                {...helpButton}
                                className="header__help-button"
                                iconClassName="button__icon--large"
                                iconLeft={PhoneIcon}
                                style="link"
                            />
                        )}
                    </GridColumn>
                </Grid>
            </Container>
        </header>
    )
}
